import { render, staticRenderFns } from "./ForcaDeVendasColaboradores.vue?vue&type=template&id=baa328a6"
import script from "./ForcaDeVendasColaboradores.vue?vue&type=script&lang=js"
export * from "./ForcaDeVendasColaboradores.vue?vue&type=script&lang=js"
import style0 from "./ForcaDeVendasColaboradores.vue?vue&type=style&index=0&id=baa328a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports